import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {lastValueFrom} from "rxjs";
import {PTPDepartmentDto, PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-ptp-department-edit",
    templateUrl: "./ptp-department-edit.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PTPDepartmentEditComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private route: ActivatedRoute,
        private router: Router,
        private message: NzMessageService,
        private fb: FormBuilder
    ) {}

    loading = true;
    isEditMode = false;
    departmentId?: number;

    form: FormGroup = this.fb.group({
        departmentName: ["", [Validators.required, Validators.maxLength(100)]]
    });

    async ngOnInit() {
        const id = this.route.snapshot.queryParamMap.get("id");
        if (!id) {
            this.loading = false;
            return;
        }

        this.isEditMode = true;
        this.departmentId = Number(id);

        try {
            const department = await lastValueFrom(this.api.getApiConfigurePtpDepartmentsId(this.departmentId));
            this.form.patchValue({departmentName: department.DepartmentName});
        } catch (e) {
            this.message.error("Failed to load department");
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    save = async () => {
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(k => this.form.get(k)?.markAsTouched());
            return;
        }

        this.loading = true;

        const dto: PTPDepartmentDto = {
            DepartmentID: this.departmentId,
            DepartmentName: this.form.value.departmentName
        };

        try {
            if (this.isEditMode) {
                await lastValueFrom(this.api.putApiConfigurePtpDepartments(dto));
                this.message.success("Department updated");
            } else {
                await lastValueFrom(this.api.postApiConfigurePtpDepartments(dto));
                this.message.success("Department created");
            }
            this.router.navigateByUrl("/configure/ptpdepartment");
        } catch (e) {
            this.message.error("Failed to save department");
            console.log(e);
            this.loading = false;
        }
    };
}
